module.exports = __webpack_public_path__ + "images/emoji/clap.93fd49db927565502a28.png";